import { Body1 } from '@cian/ui-kit';
import { IconProductDocumentsVerified24 } from '@cian/ui-kit-design-tokens/icons';

import * as React from 'react';

import { WORK_HONESTLY_MESSAGES } from '../../constants';

import * as styles from './ApprovalNew.css';

export enum EApprovalType {
  HasVerifiedDocuments = 'hasVerifiedDocuments',
}

export interface IApprovalNewProps {
  type: EApprovalType;
}

export const ApprovalNew = ({ type }: IApprovalNewProps) => {
  switch (type) {
    case EApprovalType.HasVerifiedDocuments:
      return (
        <div className={styles['container']} data-testid="approval-has-verified-documents">
          <div className={styles['icon']}>
            <IconProductDocumentsVerified24 color="icon-main-default" />
          </div>
          <Body1>{WORK_HONESTLY_MESSAGES.agent}</Body1>
        </div>
      );

    default:
      return null;
  }
};
